document.addEventListener('DOMContentLoaded', function () {
  // Popup JS.
  document.querySelectorAll('.popup-wrapper').forEach(function (item) {
    var popupId = item.dataset.popup;
    var cookie = readCookie(popupId);
    if (!cookie) {
        console.log('SHOW COOKIE')
      item.classList.remove('hidden');
    }
  });

  var popupClose = document.getElementById('js-popup-close');
  if (popupClose) {
    popupClose.addEventListener('click', function (ev) {
      ev.preventDefault();

      var el = this.closest('.popup-wrapper');
      if (!el) return;

      var popupId = el.dataset.popup;
      createCookie(popupId, true, 'Fri, 31 Dec 9999 23:59:59 GMT');

      el.classList.add('hidden');

      window.location = this.getAttribute('href');
    });
  }

  // Popup country selection.
  if (readCookie('no-drinks') === 'true') {
    document.getElementById('HeaderMenu-drinks')?.remove();
      document
    .querySelector('a[class^="ai-collection-buttons__button"][href*="/collections/drinks"]')
    ?.remove();
  }

  document.querySelectorAll('.countryselect-item').forEach(function (item) {
    item.addEventListener('click', function (ev) {
      ev.preventDefault();

      document.querySelectorAll('.countryselect-item').forEach(function (el) {
        el.classList.remove('active');
      });

      this.classList.add('active');

      if (this.dataset.value === 'non-eu-drinks') {
        // Non-EU, so no access to the drinks section.
        createCookie('no-drinks', true, 'Fri, 31 Dec 9999 23:59:59 GMT');
      } else {
        createCookie('no-drinks', false, 'Fri, 31 Dec 9999 23:59:59 GMT');
      }
    });
  });

  // Search for .js-main-product (only on product pages) and get the data-collection attribute
  // If collection is drinks and no-drinks is true => Redirect to home
  var mainProduct = document.querySelector('.js-main-product');
  if (
    mainProduct &&
    mainProduct.dataset.collection === 'drinks' &&
    readCookie('no-drinks') === 'true'
  ) {
    window.location.href = '/';
  }

  function createCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires + '; path=/';
  }

  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');   

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }

    return null;
  }

  /*
  const grid = document.querySelector('.grid-items-home-page');
  // Isotope replacement would need a separate masonry library or custom layout logic
  */
});